<script>
  import { goto } from "@sveltech/routify";
  $goto('../home')
</script>